<template>
    <v-card
    class="mx-auto"
    max-width="500"
  >
    <v-card-text>
      <v-treeview
        :items="items"
        :search="search"
        :filter="filter"
        :open.sync="open"
      >
        <template v-slot:prepend="{ item }">
          <v-icon
            v-if="item.children"
            v-text="`mdi-${item.id === 1 ? 'home-variant' : 'folder-network'}`"
          ></v-icon>
        </template>
      </v-treeview>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
    props:['items'],
    data(){
        return {
            open: false
        }
    }
}
</script>
